import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { useAuthStore } from './stores/authStore';
import LoginScreen from './components/LoginScreen';
import MainLayout from './components/MainLayout';

const theme = createTheme({
  palette: {
    primary: {
      main: '#d69524', // Golden color to match your existing design
      light: '#f5a332',
      dark: '#b87c1f',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f8fafc',
      light: '#ffffff',
      dark: '#e2e8f0',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
    text: {
      primary: '#1f2937',
      secondary: '#6b7280',
    },
  },
  typography: {
    fontFamily: 'Inter, system-ui, sans-serif',
  },
});

const App: React.FC = () => {
  const { isAuthenticated } = useAuthStore();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="min-h-screen">
        {isAuthenticated ? <MainLayout /> : <LoginScreen />}
      </div>
    </ThemeProvider>
  );
};

export default App;

